// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { Modal } from '@loa/ui-components';

type ArchiveRelationshipModalProps = Readonly<{
  open: boolean;
  relationshipName: string;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}>;

export function ArchiveRelationshipModal({
  open,
  relationshipName,
  onClose,
  onConfirm,
  loading = false,
}: ArchiveRelationshipModalProps) {
  return (
    <Modal open={open} onClose={onClose} size="small" variant="warning">
      <Modal.Header icon="archive" title="Archive Relationship" onClose={onClose} />
      <Modal.Content>
        <div className='text-black text-body-01 font-normal leading-normal font-sans'>
          Are you sure you want to archive <strong>{relationshipName}</strong>? This will archive
          all associated clients, policies, and letters of authority. This action can be reversed
          later.
        </div>
      </Modal.Content>
      <Modal.Actions
        secondaryAction={{ label: 'Cancel', onClick: onClose, disabled: loading, colour: 'red' }}
        primaryAction={{ label: 'Archive Relationship', onClick: onConfirm, loading, disabled: loading, colour: 'red' }}
      />
    </Modal>
  );
}
